import {call, put, takeLatest} from "redux-saga/effects";
import request from "../../api/request";

function* getAllExternalInventory(payload) {
  try {
    yield put({
      type: "FETCH_EXTERNAL_INVENTORY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/integrations/getSpeedInventory?pageSize=${payload.value.pageSize}`;
    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_INVENTORY_REQUESTING_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Countries",
      },
    });
    yield put({
      type: "FETCH_INVENTORY_REQUESTING_ERROR",
    });
  }
}

export function* watchExternalInventory() {
  yield takeLatest("FETCH_EXTERNAL_INVENTORY_REQUEST", getAllExternalInventory);
}
